import PropTypes from 'prop-types';
import { useState } from 'react';
import Search from './Search';
import Select from './Select';

export default function Filter({
	filteredScope,
	filteredTaxonomies,
	getLabel,
	handleFilterChange,
	handleFilterClear,
	handleSearchInput,
	isOptionDisabled,
	taxonomies,
}) {
	const [expandedSelect, setExpandedSelect] = useState(false);

	const getTaxonomies = () => {
		const filteredTaxonomies = { ...taxonomies };
		if (filteredScope) {
			delete filteredTaxonomies.scope;
		}
		return filteredTaxonomies;
	};

	return (
		<div className="jobs__controls">
			{Object.entries(getTaxonomies()).map(([taxonomyName, taxonomy]) => {
				return taxonomy.terms.length > 1 ? (
					<Select
						filteredTaxonomies={filteredTaxonomies}
						getLabel={getLabel}
						handleFilterChange={handleFilterChange}
						handleFilterClear={handleFilterClear}
						isOpen={expandedSelect === taxonomyName}
						isOptionDisabled={isOptionDisabled}
						key={taxonomyName}
						setExpandedSelect={setExpandedSelect}
						taxonomy={taxonomy}
						taxonomyName={taxonomyName}
					/>
				) : null;
			})}
			<Search searchValue={filteredTaxonomies?.q || ''} handleSearchInput={handleSearchInput} handleFilterClear={handleFilterClear} getLabel={getLabel} />
		</div>
	);
}

Filter.propTypes = {
	filteredScope: PropTypes.bool.isRequired,
	filteredTaxonomies: PropTypes.object.isRequired,
	getLabel: PropTypes.func.isRequired,
	handleFilterChange: PropTypes.func.isRequired,
	handleFilterClear: PropTypes.func.isRequired,
	handleSearchInput: PropTypes.func.isRequired,
	isOptionDisabled: PropTypes.func.isRequired,
	taxonomies: PropTypes.object.isRequired,
};
